<template>
  <div class="dialog-warp">
    <el-form ref="info" size="small" label-position="top">
      <h3 class="title">基础信息：</h3>
      <v-bill-order-info  :infoDetail="info" :noteCreateName="noteCreateName"></v-bill-order-info>
      <h3 class="title">审批流程信息：</h3>
      <div class="dialog_form  basic_info">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="activity.timestamp">
            {{activity.content}}
            <span style="color: #909399;font-size: 13px;" v-if="index == 0">{{activity.state}}</span>
            <div v-if="activity.noteRecordRemark" style="color: #909399;font-size: 13px;">审批意见：{{activity.noteRecordRemark}}</div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <h3 class="title" v-if="info.noteUploadTime">票据信息：</h3>
      <div class="dialog_form g-basic-info" v-if="info.noteUploadTime">
        <el-row>
         <el-col :span="12"><p>票据上传时间：{{info.noteUploadTime|datetime}}</p></el-col>
       </el-row>
       <el-row>
         <el-col :span="12"><p>票据确认时间：{{info.noteSureTime|datetime}}</p></el-col>
       </el-row>
       <div class="g-col-line"></div>
       <el-row>
         <el-col :span="24"><p>备注信息：{{info.noteRemark|empty}}</p></el-col>
       </el-row>
       <el-row>
         <el-col :span="24" style="display:flex;">
           <span style="line-height:30px;">票据文件：</span>
           <ul class="fileList" v-if="info.noteFile">
             <li v-for="(file,index) in info.noteFile" :key="index">
               <span class="ellipsis">{{file.fileName}}</span>
               <el-button size="mini" @click="openFile(file.exportFile)">预览</el-button>
               <el-button size="mini" @click="downLoad(file)">下载</el-button>
              </li>
           </ul>
           <span v-else style="line-height:30px;">暂无文件</span>
         </el-col>
       </el-row>
      </div>
      <div class="text-center" style="margin-top: 20px;" v-if="info.noteUploadTime&&info.noteState==2">
        <el-button type="success" @click="submit" >我已确认票据无误，确认签收</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import * as getData from "../service/getData";
  import * as global from "../config/mUtils";

  export default {
    data() {
      return {
        info:{},
        activities:[],
        noteCreateName:'',
      };
    },
    created() {
    },
    mounted() {
      this.init();
    },
    props: ['noteId'],
    computed: {},
    methods: {
      init() {
        getData.noteNoteDetail({noteId:this.noteId}).then(res => {
          if (res.data.code === 1) {
            this.info = res.data.data.note;
            this.info.noteFile = res.data.data.note.noteFile ? JSON.parse(res.data.data.note.noteFile) :'';
            this.noteCreateName = res.data.data.noteCreateName;
            this.activities = res.data.data.records.map(item=>{
              let state = ""
              let color = ""
              let content = ""
              let icon = ""
              let time = ""
              content=`${item.noteRecordName}`
              time=new Date(item.noteRecordTime).format('yyyy-MM-dd hh:mm:ss')
              if(item.noteRecordOperation == 2){
                state="审批通过"
                color='#409EFF'
                icon='el-icon-check'
              }else if(item.noteRecordOperation == 3){
                state="审批驳回"
                color='#F56C6C'
                icon='el-icon-close'
              }else if(item.noteRecordOperation == 1){
                state="发起"
                color='#409EFF'
                icon='el-icon-check'
              }else{
                content=`${item.noteRecordName}`
                time=""
              }
              item.content = content;
              item.timestamp = time;
              item.icon = icon;
              item.color = color;
              item.state = state;
              return item
            })

          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        });
      },
      submit(){
        getData.noteSure(this.noteId).then(res => {
          if (res.data.code === 1) {
            this.$message({
              message: '确认成功',
              type: "success"
            });
            this.close(1);
          } else {
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        });
      },
      openFile (url) {
        window.open(url)
      },
      downLoad(file){
       window.open('/company/download/downloadWorkflowFileUseName?fileName='+file.fileName+'&fileUrl='+file.exportFile)
      },
      close(type) {
        if (type === 1) {
          this.$emit("init");
        }
        this.$emit("closeDialog");
      }
    },
    components: {},
    watch: {}
  };
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .g-handle-manager{
    padding-left: 20px;
    padding-top: 10px;
    margin-top: 10px;
  }
  .g-executor-box{
    padding-bottom: 10px;
  }
  .dialog-form{
    box-shadow:0px 3px 10px 0px rgba(0,14,26,0.04);
    border-radius:6px;
  }
  .dialog-form{
    box-shadow:0px 3px 10px 0px rgba(0,14,26,0.04);
    border-radius:6px;
  }
</style>
<style lang="scss">
  .g-assign-item{
    .el-form-item__label{
      padding: 0;
    }
  }
  .basic_info{
    color: #333;
    border: 1px solid #e4e4e4;
    padding-bottom: 0;
    padding-top: 20px;
    margin: 10px 0;

  }
  .dialog_form{
    background: #fff;
    padding:10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/bill-examine-details.vue